import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { OrderManualDeliveryAddressDto } from './OrderManualDeliveryAddressDto'
import { OrderCdekDeliveryTimes } from './OrderCdekDeliveryTimes'
/**
* Class OrderDeliveryMethodManualDto
*  Специфика ручной доставки (без API).
*/
export class OrderDeliveryMethodManualDto extends ActiveModel {

  /**
  * kind
  *   */
  @ActiveField({ readonly: true, value: () => 'Manual' })
  readonly kind: string = 'Manual'


  /**
  * to
  * Адрес доставки.  */
  @ActiveField({
    factory: [OrderManualDeliveryAddressDto, () => undefined]
  })
  to?: OrderManualDeliveryAddressDto


  /**
  * times
  * Сроки из PeriodMin/Max каталога (если заданы).  */
  @ActiveField({
    factory: [OrderCdekDeliveryTimes, () => undefined]
  })
  times?: null | OrderCdekDeliveryTimes
}
